export default __webpack_public_path__ + "static/media/bg-horaires.8bd1a173.png";